import { useTranslation } from 'react-i18next';

export function LabelName({ name }: { name: string }) {
  const { t } = useTranslation('settings');

  return (
    <span className="break-words" title={t('viewLabelDetails')}>
      {name}
    </span>
  );
}

LabelName.displayName = 'LabelName';
